import { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import SnackbarConstants from 'utils/constants/Snackbar.js';

function useAPI(
    apiServiceFunction,
    handleSuccess = () => { },
    showSuccessAlert = false,
    immediate = false,
    handleError = () => { },
    showErrorAlert = true
) {

    const [status, setStatus] = useState('idle');
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);

    const { enqueueSnackbar } = useSnackbar();

    const execute = useCallback(
        (...args) => {
            setStatus('pending');
            setResponse(null);
            setError(null);
            return apiServiceFunction(args)
                .then((response) => {
                    setResponse(response);
                    setStatus('success');
                    handleSuccess(response);
                    if (showSuccessAlert) enqueueSnackbar(response.message, SnackbarConstants.success);
                })
                .catch((error) => {
                    setError(error);
                    setStatus('error');
                    returnError(error);
                });
        },
        [apiServiceFunction]
    );

    function returnError(error) {
        let errorData = error ? error.data : null;
        if(showErrorAlert) {
            if (errorData && errorData.message) {
                enqueueSnackbar(errorData.message, SnackbarConstants.error);
                let errors = errorData.errors;
                if (errors) {
                    errors.forEach((item) => {
                        enqueueSnackbar(item, SnackbarConstants.error);
                    });
                }
            } else {
                enqueueSnackbar('Oops! Something went wrong', SnackbarConstants.error);
            }
        }
        handleError(error);
    }

    useEffect(() => {
        if (immediate) {
            execute();
        }
    }, [execute, immediate]);

    return { execute, status, response, error };
}

export default useAPI;